import { useEffect, useState } from 'react';
import { BALL } from '../theme.js';
import { useProgress } from '../store/progress.js';

const T = BALL;
const VISIBLE_MS = 1600;
const FADE_MS = 280;

export default function Splash({ onDone }) {
  const { sourceLang: lang } = useProgress();
  const [dismissing, setDismissing] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => dismiss(), VISIBLE_MS);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function dismiss() {
    if (dismissing) return;
    setDismissing(true);
    setTimeout(onDone, FADE_MS);
  }

  return (
    <div
      onClick={dismiss}
      style={{
        position: 'fixed', inset: 0, zIndex: 100,
        background: T.primary,
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        gap: 24,
        opacity: dismissing ? 0 : 1,
        transition: `opacity ${FADE_MS}ms ease-out`,
        cursor: 'pointer',
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}
    >
      <img
        src="/dalmatian.svg"
        alt="Ballingo"
        width={200}
        height={200}
        style={{
          width: 200, height: 200, borderRadius: 44,
          boxShadow: `0 8px 0 ${T.primaryDeep}`,
          animation: 'ballingoSplashPop 480ms cubic-bezier(0.34, 1.56, 0.64, 1) both',
        }}
      />
      <div style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6,
        animation: 'ballingoSplashFade 600ms ease-out 120ms both',
      }}>
        <div style={{
          fontSize: 44, fontWeight: 900, color: '#fff',
          letterSpacing: '-0.02em', lineHeight: 1,
          textShadow: `0 3px 0 ${T.primaryDeep}`,
        }}>
          Ballingo
        </div>
        <div style={{
          fontSize: 14, fontWeight: 700, color: '#FFF1E3',
          letterSpacing: '0.04em',
        }}>
          {lang === 'en' ? 'Learn Croatian' : 'Lär dig kroatiska'}
        </div>
      </div>
    </div>
  );
}
